import React from 'react'
// libs
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  gap: 20px;

  p {
    border-left: 1px solid gray;
    padding: 20px;
  }
`

const NotFound: React.FC = () => {
  return (
    <Wrapper>
      <h1>404</h1>
      <p>Risk not found</p>
    </Wrapper>
  )
}

export default NotFound
